import { render, staticRenderFns } from "./ObjectIncluder.vue?vue&type=template&id=35017b7c&lang=pug&"
import script from "./ObjectIncluder.vue?vue&type=script&lang=js&"
export * from "./ObjectIncluder.vue?vue&type=script&lang=js&"
import style0 from "./ObjectIncluder.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35017b7c')) {
      api.createRecord('35017b7c', component.options)
    } else {
      api.reload('35017b7c', component.options)
    }
    module.hot.accept("./ObjectIncluder.vue?vue&type=template&id=35017b7c&lang=pug&", function () {
      api.rerender('35017b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/widget/ObjectIncluder.vue"
export default component.exports